import { render, staticRenderFns } from "./ItemScreenDisplayModal.vue?vue&type=template&id=3c548d95&scoped=true"
import script from "./ItemScreenDisplayModal.vue?vue&type=script&lang=js"
export * from "./ItemScreenDisplayModal.vue?vue&type=script&lang=js"
import style0 from "./ItemScreenDisplayModal.vue?vue&type=style&index=0&id=3c548d95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c548d95",
  null
  
)

export default component.exports